import React, { Component } from 'react';
import { Row, Col, ListGroup, ListGroupItem, Container,Progress, UncontrolledTooltip } from 'reactstrap';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { SvgAssets } from '../../../assets/icons/iconSvg';
import GaugeChart from 'react-gauge-chart';
import { data } from '../../../constants/Constants';
import color from '../../../constants/Colors';
import TooltipLeyenda from '../../reusable/TooltipLeyenda';
import ValorCriterio from '../../reusable/ValorCriterio';
import {SelectRuc} from '../../reusable/SelectRuc';

const WIDTH = window.innerWidth;

const LineaCredito = () => {
	return (
		<div className="line_credito">
			<h6 className="title-4">Línea de crédito</h6>
			<div className="montoCredito">
				<h6 className="paragraph-1">Línea de crédito</h6>
				<h3 className="title-3">S/ 300,000.00</h3>
				<p className="paragraph-2">79876543211 - Razón Social S.A.C</p>
			</div>
			<div className="progress-bar-credito">
				<span style={{background: '#003591', width: '40%'}}>40%</span>
				<span style={{background: color.morado, width: '30%'}}>30%</span>
				<span style={{background: color.verdeClaro, width: '30%'}}>30%</span>
			</div>
			<div className="legend-credito">
				<p><div className="dot" style={{background: '#003591'}}/>L.C. Utilizada - S/ 130.000.00</p>
				<p><div className="dot" style={{background: color.morado}}/>L.C. En carrito de compras - S/ 90.000.00</p>
				<p><div className="dot" style={{background: color.verdeClaro}}/>L.C. Disponible - S/ 80.000.00</p>
			</div>
			<h6 className="title-4">Próximos vencimientos</h6>
			<ListGroup flush>
        <ListGroupItem className="bg_gray">
          <Row form>
            <Col xs={3}>
              <span className='paragraph-3 bold' style={{ color: color.grisOscuro }}>Fecha Vcto.</span>
            </Col>
            <Col xs={4}>
              <span className='paragraph-3 bold' style={{ color: color.grisOscuro }}>Importe S/</span>
            </Col>
            <Col xs={5}>
              <span className='paragraph-3 bold' style={{ color: color.grisOscuro }}>Línea de negocio</span>
            </Col>
          </Row>
        </ListGroupItem>
				<ListGroupItem>
					<Row form>
						<Col xs={3}>
							<span className='paragraph-3 bold' style={{ color: color.azulClaro }}>10/04/2021</span>
						</Col>
						<Col xs={4}>
							<span className='paragraph-3 bold' style={{ color: color.azulClaro }}>S/ 35.000.00</span>
						</Col>
						<Col xs={4}>
							<span className='paragraph-3 bold' style={{ color: color.azulClaro }}>Vehículo 3R</span>
						</Col>
						<Col xs={1}>
							<div id="tooltip-info-1" className="tooltip-leyenda" style={{}}>
                <SvgAssets icon="icon-info" fill={color.celeste} />
                <UncontrolledTooltip placement="top" target="tooltip-info-1" className="tooltip-leyenda">
                  <span className="light" style={{ fontSize: 9 }}>texto</span>
                </UncontrolledTooltip>
              </div>
						</Col>
					</Row>
        </ListGroupItem>
      </ListGroup>
		</div>
	)
}

const CierreMes = () => {
	return (
		<div className="boxBorder cierre_mes">		
			<h4 className="paragraph-3 desktop_parrafo4 bold azul">Cierre de mes en:</h4>
			<div className="time-box mb-0">
				<div className="box">
					<strong>0</strong>
					<span>Días</span>
				</div>
				<i>:</i>
				<div className="box">
					<strong>10</strong>
					<span>Horas</span>
				</div>
				<i>:</i>
				<div className="box">
					<strong>31</strong>
					<span>Minutos</span>
				</div>
			</div>
		</div>
	)
}

export class VehiculoDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
          
    };
  }

	render() {
		const { } = this.state;
		const sliderVbox = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
			variableWidth: true,
			responsive: [
        {
          breakpoint: 600,
          settings: {
            arrows: false,
          }
        }
      ]
    };

		return (
			<div style={{ flex: 1 }}>
				<SelectRuc />
				<div className="desktop tab-pills-container">
          <div className="tab-pills">
						<button className='pill active'>Mes Actual</button>
						<button className='pill'>Mayo</button>
          </div>
          <SvgAssets className="curve-bottom" icon="curve-top" fill="#fff" />
        </div>
				<Container className="py-5 container_1270">
					<div className="row-dashboard">
						<div className="col-card" style={{maxWidth:800}}>
							<div className="card h-100">
								<div className="tab-pills mobile">
									<button className='pill active'>Mes Actual</button>
									<button className='pill'>Mayo</button>
								</div>
								<div className="scroll_Vbox" style={{background:'rgba(154, 200, 255, 0.3)'}}>
									<Slider {...sliderVbox}>
										<div>
											<div className="Vbox" style={{borderColor:color.azulClaro}}>
												<h6 style={{color:color.azulClaro}}>Pulsar<br/>12.5%</h6>
												<span style={{color:color.azulClaro}}>(Máx. 18.5%)</span>
											</div>
										</div>
										<div>
											<div className="Vbox">
												<h6>Pulsar<br/>12.5%</h6>
												<span>(Máx. 18.5%)</span>
											</div>
										</div>
										<div>
											<div className="Vbox">
												<h6>Pulsar<br/>12.5%</h6>
												<span>(Máx. 18.5%)</span>
											</div>
										</div>
										<div>
											<div className="Vbox">
												<h6>Pulsar<br/>12.5%</h6>
												<span>(Máx. 18.5%)</span>
											</div>
										</div>
									</Slider>
								</div>
								<Row>
									<Col lg="6">
										<div className="boxBorder d-flex justify-content-between">
											<span className="paragraph-2 bold azul">Descuento Base:</span>
											<span className="paragraph-1 bold verde">1.5%</span>
										</div>
									</Col>
									<Col lg="6">
										<div className="boxBorder d-flex justify-content-between">
											<span className="paragraph-2 bold azul">+ Descuento obtenido: </span>
											<span className="paragraph-1 bold verde">11%</span>
										</div>
									</Col>
								</Row>
								<div className="cards-wrap">
									<div className="card_product_vertical dashboard">
										<h6 className="title-4">Sell out:</h6>
										<ValorCriterio 
											active={true} 
											containerStyle={{alignSelf:'center',marginBottom:10}}
											value={'2%'}
										/>
										<div className="chart-sm">
											<GaugeChart id="chart1" className="gauge-chart-s"
												nrOfLevels={6} 
												cornerRadius={0}
												hideText={true}
												needleColor={color.verde}
												needleBaseColor={color.verde}
												colors={[color.verde, color.verde, color.verde,color.celesteClaro,color.celesteClaro,color.celesteClaro]}
											/>
											<span className="value_chart text-center d-block" style={{ left:0,right:0}}>0</span>
                      <span className="value_chart" style={{ left: '14%' }}>30</span>
                      <span className="value_chart" style={{ right: '12%' }}>30</span>
										</div>
									</div>
									<div className="card_product_vertical dashboard">
										<h6 className="title-4">Meta:</h6>
										<ValorCriterio 
											containerStyle={{alignSelf:'center',marginBottom:10}}
											value={'1%'}
										/>
										<div className="chart-sm">
											<GaugeChart id="chart2" className="gauge-chart-s"
												nrOfLevels={6} 
												cornerRadius={0}
												hideText={true}
												needleColor={color.verde}
												needleBaseColor={color.verde}
												colors={[color.verde, color.verde, color.verde,color.celesteClaro,color.celesteClaro,color.celesteClaro]}
											/>
											<span className="value_chart text-center d-block" style={{ left:0,right:0}}>0</span>
                      <span className="value_chart" style={{ left: '14%' }}>30</span>
                      <span className="value_chart" style={{ right: '12%' }}>30</span>
										</div>
									</div>
									<div className="card_product_vertical dashboard">
										<h6 className="title-4">Cierre de quincena en:</h6>
										<ValorCriterio 
											active={true} 
											containerStyle={{alignSelf:'center',marginBottom:10}}
											value={'2%'}
										/>
										<div className="time-box-sm">
											<div className="box">
												<span>8<br/>Días</span>
											</div>
											<div className="box">
												<span>16<br/>Hrs</span>
											</div>
											<div className="box">
												<span>50<br/>Min</span>
											</div>
										</div>
									</div>
									<div className="card_product_vertical dashboard">
										<h6 className="title-4">Sell out Bover:</h6>
										<ValorCriterio 
											active={true} 
											containerStyle={{alignSelf:'center',marginBottom:10}}
											value={'2%'}
										/>
										<div className="chart-sm">
											<GaugeChart id="chart3" className="gauge-chart-s"
												nrOfLevels={6} 
												cornerRadius={0}
												hideText={true}
												needleColor={color.verde}
												needleBaseColor={color.verde}
												colors={[color.verde, color.verde, color.verde,color.celesteClaro,color.celesteClaro,color.celesteClaro]}
											/>
											<span className="value_chart text-center d-block" style={{ left:0,right:0}}>0</span>
                      <span className="value_chart" style={{ left: '14%' }}>30</span>
                      <span className="value_chart" style={{ right: '12%' }}>30</span>
										</div>
									</div>
									<div className="card_product_vertical dashboard">
										<h6 className="title-4">Equilibrio Discover:</h6>
										<ValorCriterio 
											active={true} 
											containerStyle={{alignSelf:'center',marginBottom:10}}
											value={'2%'}
										/>
										<div className="chart-sm">
											<GaugeChart id="chart4" className="gauge-chart-s"
												nrOfLevels={6} 
												cornerRadius={0}
												hideText={true}
												needleColor={color.verde}
												needleBaseColor={color.verde}
												colors={[color.verde, color.verde, color.verde,color.celesteClaro,color.celesteClaro,color.celesteClaro]}
											/>
											<span className="value_chart text-center d-block" style={{ left:0,right:0}}>0</span>
                      <span className="value_chart" style={{ left: '14%' }}>30</span>
                      <span className="value_chart" style={{ right: '12%' }}>30</span>
										</div>
									</div>
									<div className="card_product_vertical dashboard">
										<h6 className="title-4">CIS Express</h6>
										<ValorCriterio 
											active={true} 
											containerStyle={{alignSelf:'center',marginBottom:10}}
											value={'2%'}
										/>
										<h6 className="title-4">Exclusividad</h6>
										<ValorCriterio 
											containerStyle={{alignSelf:'center',marginBottom:10}}
											value={'2%'}
										/>
										<h6 className="title-4">Al contado</h6>
										<ValorCriterio 
											containerStyle={{alignSelf:'center',marginBottom:10}}
											value={'2%'}
										/>
									</div>
								</div>
								<br className="desktop"/>
								<Row form>
									<Col lg="4">
										<div className={`boxBorder${(WIDTH > data.isSmallDevice ? ' h-100' : '')}`}>
											<h6 className="title-6">Estadística Semanal</h6>
											<div className="d-flex">
												<ValorCriterio 
													containerStyle={{alignSelf:'center'}}
													value={'1%'}
												/>
												<div className="estad-semanal">
													<div className="d-flex justify-content-around">
														<span>S1</span>
														<span>S2</span>
														<span>S3</span>
														<span>S4</span>
													</div>
													<Progress value="25" className="w-100" />
												</div>
											</div>
										</div>
									</Col>
									<Col lg="8">
										<div className={`boxBorder${(WIDTH > data.isSmallDevice ? ' h-100' : '')}`}>
											<ValorCriterio 
												containerStyle={{alignSelf:'center',position:'absolute'}}
												value={'1%'}
											/>
											<h6 className="title-6">Volumen</h6>
											<div className="scroll_Vbox">
												<Slider {...sliderVbox}>
													<div>
														<div className="Vbox" style={{background:color.naranjaClaro}}>
															<h6 style={{color:color.naranja}}>+1.0%<div style={{fontFamily:'Gotham-light'}}>16 a 25</div></h6>
														</div>
													</div>
													<div>
														<div className="Vbox" style={{background:color.naranjaClaro}}>
															<h6 style={{color:color.naranja}}>+1.0%<div style={{fontFamily:'Gotham-light'}}>16 a 25</div></h6>
														</div>
													</div>
													<div>
														<div className="Vbox" style={{background:color.celesteClaro}}>
															<h6 style={{color:color.azulClaro}}>+1.0%<div style={{fontFamily:'Gotham-light'}}>16 a 25</div></h6>
														</div>
													</div>
													<div>
														<div className="Vbox" style={{background:color.celesteClaro}}>
															<h6 style={{color:color.azulClaro}}>+1.0%<div style={{fontFamily:'Gotham-light'}}>16 a 25</div></h6>
														</div>
													</div>
												</Slider>
											</div>
											<span className="paragraph-3 d-block" style={{color:color.grisMedio}}>33 Unidades compradas hasta el momento.</span>
										</div>
									</Col>
								</Row>
								{WIDTH < data.isSmallDevice ?
									<CierreMes />: null
								}
							</div>
						</div>
						<div className="col-card" style={{flex:1}}>
							<div className="card h-100">
								<LineaCredito />
								{WIDTH > data.isSmallDevice ?
									<CierreMes />: null
								}
							</div>
						</div>
					</div>
				</Container>
			</div>
		)
	}
}